import Lenis from 'lenis';
export default {
  mounted(el) {
    const lenis = new Lenis({
      el, // Element to apply the scroll
      smooth: true, // Enable smooth scrolling
      smoothWheel: true,
      //   easing: (t) => 1 - Math.pow(1 - t, 3),
      //   wheelMultiplier: 1.2,
      //   smoothTouch: true,
      //   normalizeWheel: true
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    el.__lenis = lenis;
  },
  beforeUnmount(el) {
    el.__lenis.destroy();
  },
};
